// @ts-nocheck
import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'src/store/reducers';

import PageLayout from '@components/PageLayout';
import AddAddressForm from '@components/addresses/AddAddressForm';

import { getAddresses } from '@services/myProfileServices';

import * as actions from '@redux-actions/';

import { getLabelFallback } from '@utils/utils';
import AddressDetails from '@components/addresses/AddressDetails';
import LoaderElement from '@loaders/LoaderElement';

interface AddressGroup {
    S: IAddressDetails;
    B?: IAddressDetails;
}

const Addresses = (): JSX.Element => {
    const config = useSelector((state: RootState) => state.common.config);
    const getAddressesListRequestStatus = useSelector(
        (state: RootState) => state.myProfile.getAddressesListRequestStatus
    );
    const addressesList = useSelector((state: RootState) => state.myProfile.addressesList);

    const [isAddAddressFormOpen, setIsAddAddressFormOpen] = useState(false);
    const [addressGroups, setAddressGroups] = useState<AddressGroup[]>([]);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getAddresses(config.mockRequest, config.storeId));
        return () => {
            dispatch(actions.getAddressesPending());
        };
    }, []);

    useEffect(() => {
        if (getAddressesListRequestStatus == 'SUCCESS' && addressesList?.contact?.length) {
            const addressNickNamePattern = /^\d+_\d+_\d+$/;

            const groupedAddresses = addressesList.contact.reduce((addressGroups, address) => {
                if (
                    address.nickName.length !== 0 &&
                    addressNickNamePattern.test(address.nickName)
                ) {
                    const group = address.nickName.split('_').at(-1);

                    let addressType = null;

                    switch (address.addressType) {
                        case 'Shipping':
                            addressType = 'S';
                            break;
                        case 'Billing':
                            addressType = 'B';
                            break;
                        case 'ShippingAndBilling':
                            addressType = 'SB';
                            break;
                        default:
                            break;
                    }

                    if (addressType) {
                        addressGroups[group] = Object.assign(addressGroups[group] || {}, {
                            [addressType]: address,
                        });
                    }
                }

                return addressGroups;
            }, {});

            const groupedAddressesVal = Object.values(groupedAddresses);

            setIsAddAddressFormOpen(groupedAddressesVal.length === 0);
            setAddressGroups(groupedAddressesVal);
        } else {
            setIsAddAddressFormOpen(true);
        }
    }, [addressesList]);

    return (
        <PageLayout
            data_element_id="AccountSummary_Profile"
            hideMenu
            labelMenu={getLabelFallback('ADDRESSES_TITLE')}
            backLabel={getLabelFallback('ADDRESSES_BACK_CTA_LABEL')}
        >
            <div className="addresses">
                <div
                    role="region"
                    aria-label="My addresses page title"
                    className="primary-title mb-16"
                >
                    {getLabelFallback('ADDRESSES_TITLE')}
                </div>
                <div role="region" aria-label="My addresses page subtitle" className="mb-24">
                    {getLabelFallback('ADDRESSES_SUBTITLE')}
                </div>

                {getAddressesListRequestStatus === 'LOADING' && (
                    <div className="addresses_list">
                        <div className="container">
                            <LoaderElement height={320} />
                            <LoaderElement height={320} />
                            <LoaderElement height={320} />
                        </div>
                    </div>
                )}

                {getAddressesListRequestStatus === 'SUCCESS' && addressGroups.length > 0 && (
                    <div className="addresses_list">
                        <div className="container">
                            {addressGroups.map((addressGroup, i) => (
                                <AddressDetails
                                    key={i}
                                    shipping={addressGroup.S || addressGroup.SB}
                                    billing={addressGroup.B}
                                />
                            ))}
                        </div>
                    </div>
                )}

                {isAddAddressFormOpen ? (
                    <AddAddressForm />
                ) : (
                    <button
                        role="region"
                        aria-label="Add a new address"
                        className="primary-button button-size-medium"
                        onClick={() => {
                            setIsAddAddressFormOpen(true);
                        }}
                    >
                        Add a new address
                    </button>
                )}
            </div>
        </PageLayout>
    );
};

export default Addresses;
